const JIC_REFERRAL_KEY = "jic_referral";
const JIC_URL = "https://u.jic.io";

function cleanCode(value: string | null | undefined) {
  return (value || "").trim().toLowerCase();
}

function readUrlReferral() {
  const params = new URLSearchParams(window.location.search);
  const ref =
    params.get("ref") ||
    params.get("jic_ref") ||
    (params.get("jic_auth") === "1" ? null : params.get("code"));
  return cleanCode(ref);
}

export function rememberJicReferralFromUrl() {
  const ref = readUrlReferral();
  if (ref) localStorage.setItem(JIC_REFERRAL_KEY, ref);
  return ref;
}

export function getStoredJicReferral() {
  return cleanCode(localStorage.getItem(JIC_REFERRAL_KEY));
}

export async function resolveJicReferralCode(site: string) {
  const ref = rememberJicReferralFromUrl() || getStoredJicReferral();
  if (!ref) return "";

  try {
    const url = new URL(`${JIC_URL}/v1/referral/resolve`);
    url.searchParams.set("ref", ref);
    url.searchParams.set("site", site);
    const response = await fetch(url.toString());
    if (!response.ok) return ref;
    const data = await response.json();
    return cleanCode(data.inviteCode) || ref;
  } catch {
    return ref;
  }
}

export async function resolveJicReferralInput(site: string, input: string) {
  const ref = cleanCode(input);
  if (!ref) return "";

  try {
    const url = new URL(`${JIC_URL}/v1/referral/resolve`);
    url.searchParams.set("ref", ref);
    url.searchParams.set("site", site);
    const response = await fetch(url.toString());
    if (!response.ok) return "";
    const data = await response.json();
    const resolved = cleanCode(
      data.inviteCode || data.canonicalRef || data.referrerName
    );
    return resolved && !resolved.startsWith("0x") ? resolved : "";
  } catch {
    return "";
  }
}

export type PublishJicResult = { ok: boolean; reason?: string };

export async function publishJicSiteInviteCode(
  site: string,
  inviteCode: string
): Promise<PublishJicResult> {
  const code = cleanCode(inviteCode);
  const jwt = localStorage.getItem("jic_jwt");
  // 未登录 JIC 属预期状态:静默跳过(链上码仍是真相),不打扰纯钱包用户
  if (!code || !jwt) return { ok: false };

  const headers = {
    Authorization: `Bearer ${jwt}`,
    "Content-Type": "application/json",
  };
  const body = JSON.stringify({ site, inviteCode: code });
  try {
    const res = await fetch(`${JIC_URL}/v1/referral/site-code`, {
      method: "POST",
      headers,
      body,
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({} as { error?: string; owner?: string }));
      const reason =
        data.error === "inviteCode taken"
          ? "JIC sync failed: this invite code is already taken by another account"
          : `JIC sync failed: ${data.error || `HTTP ${res.status}`}`;
      return { ok: false, reason };
    }
    // default-code 为锦上添花,失败不阻断
    await fetch(`${JIC_URL}/v1/referral/default-code`, {
      method: "POST",
      headers,
      body,
    }).catch(() => {});
    return { ok: true };
  } catch {
    return { ok: false, reason: "JIC sync failed: network error" };
  }
}
